/**
 * Normalize address parts for comparison: trim + case-insensitive (en-US).
 * Accepts "CA" / "ca" / "California" / "california" equally once compared
 * against Google's long/short state names.
 */
export const normalizeAddressPart = (value?: string): string | undefined =>
  value?.trim().toLocaleLowerCase('en-US')

export const cityMatchesZip = (city?: string, zipCity?: string): boolean => {
  const normalizedCity = normalizeAddressPart(city)
  const normalizedZipCity = normalizeAddressPart(zipCity)
  return (
    !normalizedCity ||
    !normalizedZipCity ||
    normalizedZipCity === normalizedCity
  )
}

/**
 * Match user-entered state against Google's long_name ("California") and
 * short_name ("CA"). Comparison is case-insensitive.
 */
export const stateMatchesZip = (
  state?: string,
  zipStateLong?: string,
  zipStateShort?: string,
): boolean => {
  const normalizedState = normalizeAddressPart(state)
  const normalizedLong = normalizeAddressPart(zipStateLong)
  const normalizedShort = normalizeAddressPart(zipStateShort)

  return (
    !normalizedState ||
    (!normalizedLong && !normalizedShort) ||
    normalizedLong === normalizedState ||
    normalizedShort === normalizedState
  )
}
